import React, { Component } from "react";
import { Translate } from "react-translated";

class TypeOfCal extends Component {
  render() {
    const { type_of_call } = this.props;

    return (
      <div style={{ marginBottom: 10, width: "100%", display: "flex" }}>
        <label>
          <Translate text={`Type of Call: `} />
        </label>
        <label style={{ fontWeight: "bold", marginLeft: 10 }}>
          <Translate text={type_of_call} />
        </label>
      </div>
    );
  }
}

export default TypeOfCal;



// WEBPACK FOOTER //
// ./src/components/type-of-call.js